<template>
  <div class="bg-gray">
    <div class="form-content">
    <van-cell-group>
      <van-cell title="升级为更高星级俱乐部" is-link @click="toNext('ClubHighApply')"></van-cell>
<!--      <van-cell title="升级为理事、副主席单位" is-link @click="clubShow = true"></van-cell>-->
      <div style="height: 10px"></div>
    </van-cell-group>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    <van-dialog v-model="clubShow" title="" class="dialog-box" :showConfirmButton="false">
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <div class="dialog-step-li">1.积分要求：</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）积分≥800可升级成为理事单位</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）积分≥1000可升级成为副主席单位</div>
          </li>
        </ul>

        <div class="dialog-step-li">2.会员单位升级类别</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）理事单位</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）副主席单位</div>
          </li>
        </ul>


<!--        <div class="dialog-step-li">3.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>-->
        <div class="dialog-step-li">3.附件下载
          <div class="dialog-step-li-text"
               @click="download('2021年全国啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1621826258255-13.pdf')">
            2021年全国啦啦操七彩星级管理办法
          </div>
          <div class="dialog-step-li-text"
               @click="download('043号-全国啦啦操关于建设“全国啦啦操星级俱乐部”的通知', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1621826258255-11.pdf')">
            043号-全国啦啦操关于建设“全国啦啦操星级俱乐部”的通知
          </div>
        </div>

        <van-button type="primary" size="large" @click="toNext('ClubDanweiApply')">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="clubShow = false">我再想想</van-button>
      </div>
    </van-dialog>
  </div>
  </div>
</template>
<style scoped>
.dialog-head {
  font-size: .5rem;
  font-weight: 700;
  text-align: center;
  padding: .4rem 0 .3rem;
}

.dialog-content {
  padding: 0 .3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: .2rem 0 .3rem;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}
.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetailDanwei',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      clubShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {}
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "会员单位升级"
    that.id = this.$route.query.id;

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },

    toNext(name) {
      rbLink({name:name, query: {id: this.id} })
    },

    // 下载附件
    download(name, url) {
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: url
        }
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailDanwei.vue?9249cb64